<template>
    <b-modal id="acumulus_manager_modal">
        <template slot="modal-title">Manage Acumulus connection</template>
        <b-form ref="acumulus_manager_modal_form" v-if="project_data.connections.indexOf('Acumulus') === -1">
            <b-form-group label="Base URL of the API">
                <b-form-input
                        id="webshop_url"
                        :state="validateWebshopUrl"
                        v-model="credentials.webshop_url"
                        required/>
                <b-form-invalid-feedback :state="validateWebshopUrl">
                    Webshop URL is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="The version of the api">
                <b-form-input
                        id="version"
                        :state="validateVersion"
                        v-model="credentials.version"
                        required/>
                <b-form-invalid-feedback :state="validateVersion">
                    API version is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Contract code">
                <b-form-input
                    id="contract_code"
                    :state="validateContractCode"
                    v-model="credentials.contract_code"
                    required/>
                <b-form-invalid-feedback :state="validateContractCode">
                    Contract code is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Username">
                <b-form-input
                        id="username"
                        :state="validateUsername"
                        v-model="credentials.username"
                        required/>
                <b-form-invalid-feedback :state="validateUsername">
                    Username is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Password">
                <b-form-input
                        id="password"
                        :state="validatePassword"
                        v-model="credentials.password"
                        required/>
                <b-form-invalid-feedback :state="validatePassword">
                    Password is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Email on Error (Optional)">
                <b-form-input
                    id="email_on_error"
                    v-model="credentials.email_on_error"
                    />
            </b-form-group>
            <b-form-group label="Email on Warning (Optional)">
                <b-form-input
                    id="email_on_warning"
                    v-model="credentials.email_on_warning"
                    />
            </b-form-group>
            <hr/>
            <b-button block
                      variant="primary"
                      :disabled="authorizing"
                      @click="authorize">
                Authorize
            </b-button>
        </b-form>
        <div v-if="project_data.connections.indexOf('Acumulus') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import AcumulusConnectionService from '../../../services/AcumulusConnectionService';

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                credentials: {
                    webshop_url: 'https://api.sielsystems.nl',
                    version: 'stable',
                    username: '',
                    password: '',
                    contract_code: '',
                    email_on_error: '',
                    email_on_warning: ''
                },
                authorizing: false,
                clearing_credentials: false
            }
        },
        methods: {
            checkFields() {
                if (this.credentials.webshop_url.length <= 0) return false;
                if (this.credentials.version.length <= 0) return false;
                if (this.credentials.username.length <= 0) return false;
                if (this.credentials.password.length <= 0) return false;
                if (this.credentials.contract_code.length <= 0) return false;
                return true;
            },
            authorize(modal) {
                if (this.$refs.acumulus_manager_modal_form.checkValidity() && this.checkFields()) {
                    let self = this;
                    const body = Object.assign(
                        {project_id: this.project_data.project_id},
                        this.credentials
                    );
                    this.authorizing = true;

                    AcumulusConnectionService.authorize(body).then(res => {
                        if (res.data.success) {
                            self.credentials.webshop_url = '';
                            self.credentials.version = '';
                            self.credentials.username = '';
                            self.credentials.password = '';
                            self.credentials.contract_code = '';
                            self.$emit('acumulus-authorization-complete', this.project_data.project_id);
                        }
                        this.authorizing = false;
                    });
                } else {
                    modal.preventDefault();
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;

                AcumulusConnectionService.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'Acumulus');
                    }

                    this.clearing_credentials = false;
                });
            }
        },
        computed: {
            validateWebshopUrl() {
                return this.credentials.webshop_url.length > 0;
            },
            validateVersion() {
                return this.credentials.version.length > 0;
            },
            validateUsername() {
                return this.credentials.username.length > 0;
            },
            validatePassword() {
                return this.credentials.password.length > 0;
            },
            validateContractCode() {
                return this.credentials.contract_code.length > 0;
            }
        }
    }
</script>
